module.exports = __webpack_public_path__ + "img/1.65438ba8.jpg";